import { reverseMapEnum } from './utils/TypeConversions';
// map for different retail realms
export var REALM;
(function (REALM) {
    REALM["CN_AMAZON"] = "CNAmazon";
    REALM["EU_AMAZON"] = "EUAmazon";
    REALM["FE_AMAZON"] = "FEAmazon";
    REALM["NA_AMAZON"] = "NAAmazon";
})(REALM || (REALM = {}));
export var Region;
(function (Region) {
    Region["NA"] = "NA";
    Region["EU"] = "EU";
    Region["FE"] = "FE";
    Region["CN"] = "CN";
    Region["IN"] = "IN";
    Region["ZA"] = "ZA";
    Region["AUDIBLE_FE"] = "AUDIBLE_FE";
})(Region || (Region = {}));
export const RegionToRealm = {
    [Region.NA]: REALM.NA_AMAZON,
    [Region.EU]: REALM.EU_AMAZON,
    [Region.FE]: REALM.FE_AMAZON,
    [Region.CN]: REALM.CN_AMAZON,
    [Region.IN]: REALM.EU_AMAZON,
    [Region.ZA]: REALM.EU_AMAZON,
    [Region.AUDIBLE_FE]: REALM.FE_AMAZON,
};
export var Stage;
(function (Stage) {
    Stage["Local"] = "local";
    Stage["Test"] = "test";
    Stage["Alpha"] = "alpha";
    Stage["Beta"] = "beta";
    Stage["Gamma"] = "gamma";
    Stage["Prod"] = "prod";
})(Stage || (Stage = {}));
export var AudibleMarketplaceId;
(function (AudibleMarketplaceId) {
    AudibleMarketplaceId["AU"] = "AN7EY7DTAW63G";
    AudibleMarketplaceId["BR"] = "A10J1VAYUDTYRN";
    AudibleMarketplaceId["CA"] = "A2CQZ5RBY40XE";
    AudibleMarketplaceId["DE"] = "AN7V1F1VY261K";
    AudibleMarketplaceId["ES"] = "ALMIKO4SZCSAR";
    AudibleMarketplaceId["FR"] = "A2728XDNODOQ8T";
    AudibleMarketplaceId["IN"] = "AJO3FBRUE6J4S";
    AudibleMarketplaceId["IT"] = "A2N7FU2W2BU2ZC";
    AudibleMarketplaceId["JP"] = "A1QAP3MOU4173J";
    AudibleMarketplaceId["UK"] = "A2I9A3Q2GNFNGQ";
    AudibleMarketplaceId["US"] = "AF2M0KC94RCEA";
})(AudibleMarketplaceId || (AudibleMarketplaceId = {}));
export var AudibleBetaMarketplaceId;
(function (AudibleBetaMarketplaceId) {
    AudibleBetaMarketplaceId["AU"] = "A2AT07N6OMIWFU";
    AudibleBetaMarketplaceId["BR"] = "A31V010TU2WYEE";
    AudibleBetaMarketplaceId["CA"] = "A16QVBR1WHSTVN";
    AudibleBetaMarketplaceId["DE"] = "ABMF2NRWK6Q4Q";
    AudibleBetaMarketplaceId["ES"] = "ARV4E8CS3V0UR";
    AudibleBetaMarketplaceId["FR"] = "A1PM6UBHJK3SLV";
    AudibleBetaMarketplaceId["IN"] = "A3G8SHMNK6Y7PK";
    AudibleBetaMarketplaceId["IT"] = "A2ITDZXD3G7XX6";
    AudibleBetaMarketplaceId["JP"] = "ARGSKDDBM3ISN";
    AudibleBetaMarketplaceId["UK"] = "A298HDQ29ZA38N";
    AudibleBetaMarketplaceId["US"] = "A3G3TQ0ISIOPG8";
})(AudibleBetaMarketplaceId || (AudibleBetaMarketplaceId = {}));
export var PrimeVideoMarketplaceId;
(function (PrimeVideoMarketplaceId) {
    PrimeVideoMarketplaceId["US"] = "ART4WZ8MWBX2Y";
    PrimeVideoMarketplaceId["UK"] = "A3K6Y4MI8GDYMT";
    PrimeVideoMarketplaceId["EU"] = "A2MFUE2XK8ZSSY";
    PrimeVideoMarketplaceId["FE"] = "A15PK738MTQHSO";
})(PrimeVideoMarketplaceId || (PrimeVideoMarketplaceId = {}));
export var FreshStoresMarketplaceId;
(function (FreshStoresMarketplaceId) {
    FreshStoresMarketplaceId["US"] = "A1VA89I9GO62U2";
    FreshStoresMarketplaceId["UK"] = "A3P3DP59YHPL03";
})(FreshStoresMarketplaceId || (FreshStoresMarketplaceId = {}));
export var AmazonGoMarketplaceId;
(function (AmazonGoMarketplaceId) {
    AmazonGoMarketplaceId["US"] = "A260JPYZJUXIHF";
})(AmazonGoMarketplaceId || (AmazonGoMarketplaceId = {}));
export var IMBDMarketplaceId;
(function (IMBDMarketplaceId) {
    IMBDMarketplaceId["US"] = "A1EVAM02EL8SFB";
})(IMBDMarketplaceId || (IMBDMarketplaceId = {}));
export var WootMarketplaceId;
(function (WootMarketplaceId) {
    WootMarketplaceId["US"] = "A22ZUEY6FG8RY";
})(WootMarketplaceId || (WootMarketplaceId = {}));
export var ShopbopMarketplaceId;
(function (ShopbopMarketplaceId) {
    ShopbopMarketplaceId["US"] = "A2817T8MKXE20N";
})(ShopbopMarketplaceId || (ShopbopMarketplaceId = {}));
export var AmazonPayMarketplaceId;
(function (AmazonPayMarketplaceId) {
    AmazonPayMarketplaceId["US"] = "AGWSWK15IEJJ7";
    AmazonPayMarketplaceId["UK"] = "A2WQPBGJ59HSXT";
    AmazonPayMarketplaceId["DE"] = "A1OCY9REWJOCW5";
})(AmazonPayMarketplaceId || (AmazonPayMarketplaceId = {}));
export var AmazonShippingMarketplaceId;
(function (AmazonShippingMarketplaceId) {
    AmazonShippingMarketplaceId["US"] = "A2BR6UVHX99FEC";
    AmazonShippingMarketplaceId["UK"] = "AGJTXQVCWGLM9";
    AmazonShippingMarketplaceId["IT"] = "A1MXLG8EWCHHOD";
    AmazonShippingMarketplaceId["ES"] = "A26E6P270LY5LP";
    AmazonShippingMarketplaceId["IN"] = "A2ACQFO88DPSZS";
})(AmazonShippingMarketplaceId || (AmazonShippingMarketplaceId = {}));
export var AmazonAffiliateProgramMarketplaceId;
(function (AmazonAffiliateProgramMarketplaceId) {
    AmazonAffiliateProgramMarketplaceId["DE"] = "A53RDEWN57UU5";
})(AmazonAffiliateProgramMarketplaceId || (AmazonAffiliateProgramMarketplaceId = {}));
export const AUDIBLE_MARKETPLACE_IDS = [
    ...Object.values(AudibleBetaMarketplaceId),
    ...Object.values(AudibleMarketplaceId),
];
// Audible entries should go in the above enums
// For future entries, you can use https://w.amazon.com/bin/view/MarketplaceID as a reference
export var MarketplaceId;
(function (MarketplaceId) {
    MarketplaceId["US"] = "ATVPDKIKX0DER";
    MarketplaceId["UK"] = "A1F83G8C2ARO7P";
    MarketplaceId["IN"] = "A21TJRUUN4KGV";
    MarketplaceId["IE"] = "A28R8C7NBKEWEA";
    MarketplaceId["JP"] = "A1VC38T7YXB528";
    MarketplaceId["CA"] = "A2EUQ1WTGCTBG2";
    MarketplaceId["BR"] = "A2Q3Y263D00KWC";
    MarketplaceId["MX"] = "A1AM78C64UM0Y8";
    MarketplaceId["BE"] = "AMEN7PMS3EDWL";
    MarketplaceId["EG"] = "ARBP9OOSHTCHU";
    MarketplaceId["ES"] = "A1RKKUPIHCS9HS";
    MarketplaceId["IT"] = "APJ6JRA9NG5V4";
    MarketplaceId["FR"] = "A13V1IB3VIYZZH";
    MarketplaceId["DE"] = "A1PA6795UKMFR9";
    MarketplaceId["NL"] = "A1805IZSGTT6HS";
    MarketplaceId["PL"] = "A1C3SOZRARQ6R3";
    MarketplaceId["SA"] = "A17E79C6D8DWNP";
    MarketplaceId["SE"] = "A2NODRKZP88ZB9";
    MarketplaceId["TR"] = "A33AVAJ2PDY3EV";
    MarketplaceId["AE"] = "A2VIGQ35RCS4UG";
    MarketplaceId["AU"] = "A39IBJ37TRP1C6";
    MarketplaceId["SG"] = "A19VAU5U5O7RUS";
    MarketplaceId["CN"] = "AAHKV2X7AFYLW";
    MarketplaceId["ZA"] = "AE08WJ6YKNBMC";
})(MarketplaceId || (MarketplaceId = {}));
/*
 * all marketplaces across different verticals
 * */
const AllMarketplaces = [
    MarketplaceId,
    AudibleMarketplaceId,
    IMBDMarketplaceId,
    AmazonGoMarketplaceId,
    FreshStoresMarketplaceId,
    PrimeVideoMarketplaceId,
    ShopbopMarketplaceId,
    AmazonPayMarketplaceId,
    AmazonShippingMarketplaceId,
    AmazonAffiliateProgramMarketplaceId,
];
export const AllMarketplacesIds = AllMarketplaces.flatMap((el) => Object.values(el));
export const MarketplaceIdToCountry = Object.assign({}, ...AllMarketplaces.map((el) => reverseMapEnum(el)), reverseMapEnum(AudibleBetaMarketplaceId));
export const ConnectTenants = {
    Retail: 'retail',
    Audible: 'audible',
    IMDB: 'imdb',
    Shopbop: 'shopbop',
    Woot: 'woot',
};
export const DEFAULT_CONNECT_TENANT = ConnectTenants.Retail;
export var FlowStatus;
(function (FlowStatus) {
    FlowStatus["NONE"] = "NONE";
    FlowStatus["LOADING"] = "LOADING";
    FlowStatus["READY"] = "READY";
    FlowStatus["FAILED"] = "FAILED";
})(FlowStatus || (FlowStatus = {}));
// For future entries, you can use https://w.amazon.com/bin/view/MarketplaceID as a reference
// For current mappings, you can use https://w.amazon.com/bin/view/CS_Aviary/Globalization_Program/#HAviaryGlobalExpansion for reference
export const MarketplaceIdToRegion = {
    [MarketplaceId.IN]: Region.EU,
    [MarketplaceId.IE]: Region.EU,
    [MarketplaceId.UK]: Region.EU,
    [MarketplaceId.US]: Region.NA,
    [MarketplaceId.JP]: Region.FE,
    [MarketplaceId.CA]: Region.NA,
    [MarketplaceId.BR]: Region.NA,
    [MarketplaceId.MX]: Region.NA,
    [MarketplaceId.BE]: Region.EU,
    [MarketplaceId.EG]: Region.EU,
    [MarketplaceId.ES]: Region.EU,
    [MarketplaceId.IT]: Region.EU,
    [MarketplaceId.FR]: Region.EU,
    [MarketplaceId.DE]: Region.EU,
    [MarketplaceId.NL]: Region.EU,
    [MarketplaceId.PL]: Region.EU,
    [MarketplaceId.SA]: Region.EU,
    [MarketplaceId.SE]: Region.EU,
    [MarketplaceId.TR]: Region.EU,
    [MarketplaceId.AE]: Region.EU,
    [MarketplaceId.AU]: Region.FE,
    [MarketplaceId.SG]: Region.FE,
    [MarketplaceId.CN]: Region.CN,
    [MarketplaceId.ZA]: Region.EU,
    [AudibleMarketplaceId.DE]: Region.EU,
    [AudibleMarketplaceId.UK]: Region.EU,
    [AudibleMarketplaceId.ES]: Region.EU,
    [AudibleMarketplaceId.FR]: Region.EU,
    [AudibleMarketplaceId.IT]: Region.EU,
    [AudibleMarketplaceId.IN]: Region.IN,
    [AudibleMarketplaceId.JP]: Region.FE,
    [AudibleMarketplaceId.US]: Region.NA,
    [AudibleMarketplaceId.CA]: Region.NA,
    [AudibleMarketplaceId.BR]: Region.NA,
    [AudibleMarketplaceId.AU]: Region.FE,
    [FreshStoresMarketplaceId.US]: Region.NA,
    [FreshStoresMarketplaceId.UK]: Region.EU,
    [PrimeVideoMarketplaceId.US]: Region.NA,
    [PrimeVideoMarketplaceId.UK]: Region.EU,
    [PrimeVideoMarketplaceId.EU]: Region.EU,
    [PrimeVideoMarketplaceId.FE]: Region.FE,
    [AmazonGoMarketplaceId.US]: Region.NA,
    [IMBDMarketplaceId.US]: Region.NA,
    [WootMarketplaceId.US]: Region.NA,
    [ShopbopMarketplaceId.US]: Region.NA,
    [AmazonPayMarketplaceId.US]: Region.NA,
    [AmazonPayMarketplaceId.UK]: Region.EU,
    [AmazonPayMarketplaceId.DE]: Region.EU,
    [AmazonShippingMarketplaceId.US]: Region.NA,
    [AmazonShippingMarketplaceId.UK]: Region.EU,
    [AmazonShippingMarketplaceId.IT]: Region.EU,
    [AmazonShippingMarketplaceId.ES]: Region.EU,
    [AmazonShippingMarketplaceId.IN]: Region.EU,
    [AmazonAffiliateProgramMarketplaceId.DE]: Region.EU,
};
// This is a temporary solution for dealing with external links for different languages(marketplaces)
// Previously, we did the link mapping with old translation system,
// but this is not doable with Panther right now, and also probably should not be done through panther.
// CS Sapphire is looking into automatically generate this mapping during initialization
// For future entries, you can use https://w.amazon.com/bin/view/MarketplaceID as a reference
export const MarketplaceIdToRetailURL = {
    [MarketplaceId.IN]: 'https://www.amazon.in',
    [MarketplaceId.IE]: 'https://www.amazon.ie',
    [MarketplaceId.UK]: 'https://www.amazon.co.uk',
    [MarketplaceId.US]: 'https://www.amazon.com',
    [MarketplaceId.JP]: 'https://www.amazon.co.jp',
    [MarketplaceId.CA]: 'https://www.amazon.ca',
    [MarketplaceId.BR]: 'https://www.amazon.com.br',
    [MarketplaceId.MX]: 'https://www.amazon.com.mx',
    [MarketplaceId.BE]: 'https://www.amazon.com.be',
    [MarketplaceId.EG]: 'https://www.amazon.eg',
    [MarketplaceId.ES]: 'https://www.amazon.es',
    [MarketplaceId.IT]: 'https://www.amazon.it',
    [MarketplaceId.FR]: 'https://www.amazon.fr',
    [MarketplaceId.DE]: 'https://www.amazon.de',
    [MarketplaceId.NL]: 'https://www.amazon.nl',
    [MarketplaceId.PL]: 'https://www.amazon.pl',
    [MarketplaceId.SA]: 'https://www.amazon.sa',
    [MarketplaceId.SE]: 'https://www.amazon.se',
    [MarketplaceId.TR]: 'https://www.amazon.com.tr',
    [MarketplaceId.AE]: 'https://www.amazon.ae',
    [MarketplaceId.AU]: 'https://www.amazon.com.au',
    [MarketplaceId.SG]: 'https://www.amazon.sg',
    [MarketplaceId.CN]: 'https://www.amazon.cn',
    [MarketplaceId.ZA]: 'https://www.amazon.co.za',
    [AudibleMarketplaceId.DE]: 'https://www.audible.de',
    [AudibleMarketplaceId.UK]: 'https://www.audible.co.uk',
    [AudibleMarketplaceId.ES]: 'https://www.audible.es',
    [AudibleMarketplaceId.JP]: 'https://www.audible.co.jp',
    [AudibleMarketplaceId.IT]: 'https://www.audible.it',
    [AudibleMarketplaceId.IN]: 'https://www.audible.in',
    [AudibleMarketplaceId.US]: 'https://www.audible.com',
    [AudibleMarketplaceId.AU]: 'https://www.audible.com.au',
    [AudibleMarketplaceId.CA]: 'https://www.audible.ca',
    [AudibleMarketplaceId.BR]: 'https://www.audible.com.br',
    [AudibleMarketplaceId.FR]: 'https://www.audible.fr',
    [PrimeVideoMarketplaceId.US]: 'https://www.amazonvideo.com',
    [FreshStoresMarketplaceId.US]: 'https://www.amazon.com/fresh',
    [FreshStoresMarketplaceId.UK]: 'https://www.amazon.co.uk/fresh',
    [PrimeVideoMarketplaceId.UK]: 'https://www.amazon.co.uk/primevideo',
    [PrimeVideoMarketplaceId.EU]: 'https://www.amazon.co.uk/primevideo',
    [AmazonGoMarketplaceId.US]: 'https://www.amazon.com/go',
    [WootMarketplaceId.US]: 'https://www.woot.com/',
    [ShopbopMarketplaceId.US]: 'https://www.shopbop.com',
    [AmazonPayMarketplaceId.US]: 'https://pay.amazon.com/',
    [AmazonPayMarketplaceId.UK]: 'https://pay.amazon.co.uk/',
    [AmazonPayMarketplaceId.DE]: 'https://pay.amazon.de/',
    [AmazonShippingMarketplaceId.US]: 'https://shipping.amazon.com',
    [AmazonShippingMarketplaceId.UK]: 'https://shipping.amazon.co.uk',
    [AmazonShippingMarketplaceId.IT]: 'https://shipping.amazon.it',
    [AmazonShippingMarketplaceId.ES]: 'https://shipping.amazon.es',
    [AmazonShippingMarketplaceId.IN]: 'https://shipping.amazon.in',
    [AmazonAffiliateProgramMarketplaceId.DE]: 'https://partnernet.amazon.de/',
};
export var RoutingSystem;
(function (RoutingSystem) {
    RoutingSystem[RoutingSystem["GACD"] = 0] = "GACD";
    RoutingSystem[RoutingSystem["CONNECT"] = 1] = "CONNECT";
    RoutingSystem[RoutingSystem["NONE"] = 2] = "NONE";
})(RoutingSystem || (RoutingSystem = {}));
//Basic feature name controlling access to research and resolve
export const RESEARCH_AND_RESOLVE_BASIC_FEATURE_NAME = 'CSC-UI-Widget-ResearchFeature';
/**
 * This should align with character limit of Andes string metrics
 */
export const MAX_STRING_LENGTH = 256;
// Mase Landing Page will use this to call openTab.
export const SHELL_COMPONENT_ID = 'shell';
export const MODULE_COMMONS_REGION_SYMBOL_KEY = 'namespace.CSC-UI-Module-Commons.region';
// TODO:  Remove experimental code https://sim.amazon.com/issues/caracara-41297
export const DISABLE_LOGS_FEATURE_FLAG = 'disable_logs';
export const USE_STRICT_LOG_LEVEL_FEATURE_FLAG = 'use_strict_log_level';
export const landingPageComponentIdSet = new Set(['cardinal', 'sds-component', 'sds-native']);
export var AutoResolveInteractionActionPopulateComponentKeys;
(function (AutoResolveInteractionActionPopulateComponentKeys) {
    AutoResolveInteractionActionPopulateComponentKeys["ACW_TIME_OUT"] = "ACW_TIME_OUT";
    AutoResolveInteractionActionPopulateComponentKeys["LOG_OUT"] = "LOG_OUT";
    AutoResolveInteractionActionPopulateComponentKeys["CALL_BACK_CONNECTED"] = "CALL_BACK_CONNECTED";
    AutoResolveInteractionActionPopulateComponentKeys["CALL_BACK_FAILED_CONNECT_AGENT"] = "CALL_BACK_FAILED_CONNECT_AGENT";
    AutoResolveInteractionActionPopulateComponentKeys["CALL_BACK_CONNECTING_MISSED"] = "CALL_BACK_CONNECTING_MISSED";
})(AutoResolveInteractionActionPopulateComponentKeys || (AutoResolveInteractionActionPopulateComponentKeys = {}));
export const AutoResolveInteractionActionPopulateComponentValues = {
    [AutoResolveInteractionActionPopulateComponentKeys.ACW_TIME_OUT]: 'Auto-Resolved by AC3 - ACW timer expiration',
    [AutoResolveInteractionActionPopulateComponentKeys.LOG_OUT]: 'Auto-Resolved by AC3 - Abrupt CSA logout while handling a contact',
    [AutoResolveInteractionActionPopulateComponentKeys.CALL_BACK_CONNECTED]: 'Auto-Resolved in AC3 - Callback Connected.',
    [AutoResolveInteractionActionPopulateComponentKeys.CALL_BACK_FAILED_CONNECT_AGENT]: 'Auto-Resolved in AC3 - Callback Failed to connect the agent.',
    [AutoResolveInteractionActionPopulateComponentKeys.CALL_BACK_CONNECTING_MISSED]: 'Auto-Resolved in AC3 - Callback missed by the customer',
};
export const NOT_APPLICABLE_ID_VALUE = 'na';
export const UNDEFINED_ID_VALUE = 'undefined';
//# sourceMappingURL=Constants.js.map